import axiosCall from './interceptor';
import URL from '../helper';


export const getSearchMetaKeys = async (jobId) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/keys/${jobId}`;
  let response = await axiosCall('get', url); 
  return response.data ;
}

export const getJobRecords = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/search`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const getEmailDetails = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}email/delivered/preview/${payload}`;
  let response = await axiosCall('get', url); 
  return response.data ;
}

export const handleApproval = async (payload) => {
  const url = `${URL.TRACKING_SYSTEM_URL}approvalProcess`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const getJobStats = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/stats`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const getJobRecordDataset = async (transactionId, channel) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/payload/${transactionId}?channel=${channel}`;
  let response = await axiosCall('get', url); 
  return response.data ;
}

export const getChannelStats = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/stats2`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

// This API will allow processing without approval or re-initiating jobs.
export const handleApprovalProcess = async ({ jobId, proceedWithoutApproval }) => {
  const url = `${URL.BATCH_SYSTEM_URL}reInitiateJob?jobId=${jobId}&proceedWithoutApproval=${proceedWithoutApproval}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const postExclusions = async (payload) => {
  const url = `${URL.TRACKING_SYSTEM_URL}metadata/exclusion`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const postHybridExclusions = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/exclude`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const revertHybridExclusions = async (jobId) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/unExclude?exclusionId=${jobId}`;
  let response = await axiosCall('patch', url); 
  return response.data ;
}

export const getHybridExclusions = async (jobId) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/exclusions?batchId=${jobId}`;
  let response = await axiosCall('get', url); 
  return response.data;
}

export const getExclusions = async (jobId, channel) => {
  const url = `${URL.TRACKING_SYSTEM_URL}metadata/exclusion?jobId=${jobId}&channel=${channel}`;
  let response = await axiosCall('get', url); 
  return response.data;
}

export const sendForPrinting = async ( payload ) => {
  const url = `${URL.BATCH_SYSTEM_URL}sendPrint`;
  let response = await axiosCall('post', url, payload); 
  return response.data;
}

export const sendForDelivery = async payload => {
  const url = `${URL.BATCH_SYSTEM_URL}sendEmail`;
  let response = await axiosCall('post', url, payload); 
  return response.data;
}

export const fetchExclusionsData = async ( payload ) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/exclusions`;
  let response = await axiosCall('post', url, payload); 
  return response.data;
}

export const getPrintBatchList = async ( jobId, printStatus ) => {
  const url = `${URL.BATCH_SYSTEM_URL}printBatch?jobId=${jobId}&printStatus=${printStatus}`;
  let response = await axiosCall('get', url); 
  return response.data;
}

export const rescheduleBatch = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/rescheduleBatch`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const approveBatch = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/approveBatch`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const abortBatch = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/abortBatch`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const abortAdvancedBatch = async payload => {
  const url = `${URL.BATCH_SYSTEM_URL}abortBatch`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const rejectHybridBatch = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/rejectApproval`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const saveBatchInfo = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}saveBatch`;
  let response = await axiosCall('post',url,payload);
  return response.data;
}

export const updateBatchInfo = async payload =>{
  const url = `${URL.BATCH_SYSTEM_URL}updateBatch`;
  let response = await  axiosCall('patch', url, payload);
  return response.data;
}

export const proceedProof = async(payload, islastFive = false)=>{
  const url = `${URL.BATCH_SYSTEM_URL}metadata/listProofs?lastFiveProofs=${islastFive}`;
  let response = await axiosCall('post',url,payload);
  return response.data;
}

export const createAdvancedBatch = async(payload)=>{
  const url = `${URL.BATCH_SYSTEM_URL}createBatch`;
  let response = await axiosCall('post',url,payload);
  return response;
}

export const proofApproval = async (payload) =>{
  const url = `${URL.BATCH_SYSTEM_URL}proofApproval`;
  let response = await axiosCall('post', url, payload);
  return response;
}

export const batchSchedule =async(payload)=>{
  const url = `${URL.BATCH_SYSTEM_URL}scheduleBatch`;
  let response = await axiosCall('post',url, payload);
  return response; 
}

export const fetchBatchDetails = async ( batchId, isHybrid ) => {
  const url = `${URL.TRACKING_SYSTEM_URL}fetchBatchDetails/${batchId}?isHybrid=${isHybrid}`;
  let response = await axiosCall('get', url); 
  return response.data;
}

export const saveBatchConfig = async payload => {
  const url = `${URL.BATCH_SYSTEM_URL}configure`;
  const response = await axiosCall('patch', url, payload);
  return response;
};

export const getDraftBatchInfo = async batchId => {
  const url = `${URL.BATCH_SYSTEM_URL}batchDetails?batchId=${batchId}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const discardDraftBatch = async batchId => {
  const url = `${URL.BATCH_SYSTEM_URL}deleteBatch?batchId=${batchId}`;
  const response = await axiosCall('delete', url);
  return response.data;
};

export const rescheduleAdvancedBatch = async payload => {
  const url = `${URL.BATCH_SYSTEM_URL}rescheduleBatch`;
  const response = await axiosCall('patch', url, payload);
  return response;
};
export const hybridDiscardDraft = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/discardBatch`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const archiveBatches = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}batches/archiveStatus`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};
